import { isEmpty, size, forEach, get, split } from 'lodash';
import { getLocalCountryLanguage } from './utils';
import { DEFAULT_REDUX_KEY } from '../lib/dynamicStore/constants';
import { addProductRecommendation } from '../global/actions';

class CartRecommendation {
  getParams = cardData => {
    const { localeCountry = '', localeLanguage = '' } = getLocalCountryLanguage();
    const { entries = [], totalItems = 0 } = cardData;
    let cartIds = '';
    if (size(entries) > 0) {
      forEach(entries, item => {
        const code = `${item?.product?.code}:${localeCountry}:${localeLanguage}`;
        if (isEmpty(cartIds)) {
          cartIds = `${code}`;
        } else {
          cartIds = `${cartIds},${code}`;
        }
      });
    }
    return {
      pageType: 'cart',
      cartIds,
      cartItemCount: totalItems,
      isCartEmpty: totalItems === 0,
      country: localeCountry,
      language: localeLanguage,
    };
  };

  callCartRecommendationEvent = async (cardData = {}) =>
    new Promise((resolve, reject) => {
      if (window?.adobe?.target) {
        const params = this.getParams(cardData);
        window.adobe.target.getOffer({
          mbox: 'cartView',
          params,
          success: async offer => {
            await window.adobe.target.applyOffer({
              mbox: 'cartView',
              offer,
            });
            window.offer = offer;
            const offerData = get(offer, ['0', 'content'], {});
            let resultSet = {};
            if (!isEmpty(offerData)) {
              resultSet = JSON.parse(offerData);
            }
            const activityDetails1 = get(resultSet, 'activityDetails1', {});
            const result = resultSet?.results?.slice(0, 4);
            const resultList = [];
            if (size(result) > 0) {
              forEach(result, item => {
                const { id } = item;
                const splitId = split(id, ':');
                const selectedId = get(splitId, '0', '');
                resultList.push({
                  ...item,
                  id: selectedId,
                  productID: id,
                  isLoading: true,
                  activityDetails1,
                });
              });
            }
            if (window[DEFAULT_REDUX_KEY]) {
              window[DEFAULT_REDUX_KEY].dispatch(addProductRecommendation(resultList));
            }
            resolve(resultList);
          },
          error: err => reject(err),
        });
      }
    });
}

const cartRecommendation = new CartRecommendation();

export default cartRecommendation;
